<template>
  <div class="p-grid p-chat">
    <div class="p-col-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="manager-title">{{ title }}</div>
      <List />
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices';

import List from './list'

export default {
  components: {
    List
  },
  data() {
    return {
     items_bread_crumb: [
        { label: 'Chat'},
      ],
      dataModel: null,
      modelName: '',
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      title: 'Chat',
      socket: null
    };
  },

  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    // console.log('this.dataModel:', this.dataModel);
    this.title = this.dataModel.name;
    this.$store.commit('setLoading', true);
    if (this.$route.params.reload) {
      window.location.reload();
    }
    var arr_role = await this.$CoreService.checkPermission(
      this.$constants.KEY_MENU.LIST_CHAT
    );
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0) {
      this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
    }
    // console.log("arr_role:" ,arr_role)
    
    // this.role.add =
    //   arr_role.indexOf(this.$constants.ROLE.ADD) < 0 ? false : true;
    // this.role.edit =
    //   arr_role.indexOf(this.$constants.ROLE.EDIT) < 0 ? false : true;
    // this.role.delete =
    //   arr_role.indexOf(this.$constants.ROLE.DELETE) < 0 ? false : true;
  },

  mounted() {
    this.initParams()
  },

  methods: {
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
    },

  },
};
</script>
